let _this, searchParams = {
  sortName: "lastUpdateTime",
  sortType: 1,
  page: 1,
  perPage: 10,
  enabledPaging: true
}
export default {
  data() {
    _this = this;
    return {
      titleData: [
        { title: 'Video File Name', slot: 'videoName', minWidth: 200 },
        { title: 'Video Time Period', slot: 'period', minWidth: 300 },
        { title: 'Video Amount', key: 'videoCount', minWidth: 170 },
        { title: 'Generated Time', slot: 'lastUpdateTime', minWidth: 200, sortable: 'custom', sortType: 'desc' },
        { title: 'Status', slot: 'status', minWidth: 150 },
        { title: 'Operator', slot: 'operatorName', minWidth: 140 },
        { title: 'Operation', slot: 'operation', minWidth: 200, fixed: 'right' }
      ],
      searchParams: JSON.parse(JSON.stringify(searchParams)),
      tableData: [],
      generateStatus: { '0': 'Generating', '1': 'Generated', '2': 'Abnormal', '3': 'Failed' },
      deleteModal: false,
      deleteIds: '',
      isTableLoading: true,
    }
  },
  mounted() {
    _this = this;
    _this.getTableData();
  },
  methods: {
    //获取列表
    getTableData: function () {
      _this.$set(_this, 'tableData', []);
      _this.isTableLoading = true;
      this.$ajax.post('VideoRecord/Paging', _this.searchParams, { headers: { noLoading: true } }).then(function (res) {
        if (res.data.success) {
          _this.tableData = res.data.data.items;
          _this.tableData.forEach(item => {
            _this.$set(item, 'isLoading', false)
          })
        } else {
          _this.$set(_this, 'tableData', []);
        }
        _this.isTableLoading = false;
      })
    },
    // 列表排序
    sortTable: function (data) {
      this.shareApi.sortTable(this, data, this.getTableData);
    },
    download: function (row) {
      _this.tableData.forEach(item => {
        if (row.id === item.id) {
          _this.$set(item, 'isLoading', true)
        }
      })
      this.$ajax.get('VideoRecord/Download/' + row.id, { responseType: "blob", headers: { noLoading: true } }).then(function (res) {
        let blob = res.data;
        let a = document.createElement("a");
        a.download = row.name + "_" + new Date().getTime() + ".zip";
        a.style.display = "none";
        a.href = window.URL.createObjectURL(blob);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        _this.tableData.forEach(item => {
          if (row.id === item.id) {
            _this.$set(item, 'isLoading', false)
          }
        })
      })
    },
    deleteRecord: function (id) {
      _this.deleteIds = id
      _this.deleteModal = true;
    },
    confirmDelete: function () {
      this.$ajax.delete('VideoRecord/Delete?id=' + _this.deleteIds).then(function (res) {
        if (res.data.success) {
          _this.messageNotice('success', 3);
          _this.deleteModal = false;
          _this.getTableData();
        }
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/admin/components/downloadCenters/videoDownload.js